import Box from 'shared/components/Box';

import {
  DEFAULT_IMAGE_SRC,
  ImagePropTypes,
  IMAGE_PLACEHOLDERS,
  PIXELS_IN_1_REM,
} from './config';

const ImageComponent = ({
  alt = '',
  className = '',
  height,
  src,
  width,
  borderRadius,
  type,
}) => (
  <Box
    as="span"
    style={{
      display: 'block',
      width: `${width / PIXELS_IN_1_REM}rem`,
      height: `${height / PIXELS_IN_1_REM}rem`,
      borderRadius: borderRadius ? `${borderRadius}%` : `0`,
      overflow: 'hidden',
    }}
  >
    <img
      alt={alt}
      className={className}
      height={height}
      onError={(e) => {
        e.target.src = IMAGE_PLACEHOLDERS[type] || DEFAULT_IMAGE_SRC;
      }}
      src={src}
      width={width}
    />
  </Box>
);

ImageComponent.propTypes = ImagePropTypes;

export default ImageComponent;
